import { c as _c } from "react/compiler-runtime";
import { Suspense, useRef, useState, useMemo, startTransition, SetStateAction } from 'react';
import { useClientOnly } from '@/hooks/useClientOnly';
import { CardImageOnRight } from './CardImageOnRight';
import { CardImageOnLeft } from './CardImageOnLeft';
import { Card as CardProps, ImagePosition } from './types';
import { Tabs } from './Tabs';
import { useScroll } from 'framer-motion';
import throttle from 'lodash.throttle';
import { getMediaQuery } from '@/styles/sizes';
import useMediaQuery from '@/hooks/useMediaQuery';
interface Props {
  cards: Omit<CardProps, 'index'>[];
  showTab?: boolean;
  imagePosition: ImagePosition;
}
function StackCardsComponent(props) {
  const $ = _c(29);
  if (props.cards.length > 5) {
    throw new Error("StackCards must have 5 or less cards");
  }
  let t0;
  if ($[0] !== props.cards) {
    t0 = props.cards.map(_temp);
    $[0] = props.cards;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tabs = t0;
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ref = useRef(null);
  const {
    isClient
  } = useClientOnly();
  const t1 = isClient ? ref : undefined;
  let t2;
  if ($[2] !== t1) {
    t2 = {
      target: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    scrollYProgress
  } = useScroll(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = throttle(value => {
      startTransition(() => {
        setActiveTab(value);
      });
    }, 500);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const throttledSetActiveTab = t3;
  let t4;
  if ($[5] !== props.cards || $[6] !== props.imagePosition || $[7] !== scrollYProgress) {
    let t5;
    if ($[9] !== props.cards.length || $[10] !== props.imagePosition || $[11] !== scrollYProgress) {
      t5 = (card_0, index_0) => ({
        ...card_0,
        index: index_0,
        totalCards: props.cards.length,
        setActiveTab: throttledSetActiveTab,
        scrollYProgress,
        imagePosition: props.imagePosition
      });
      $[9] = props.cards.length;
      $[10] = props.imagePosition;
      $[11] = scrollYProgress;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = props.cards.map(t5);
    $[5] = props.cards;
    $[6] = props.imagePosition;
    $[7] = scrollYProgress;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const memoizedCards = t4;
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getMediaQuery("md");
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const isDesktop = useMediaQuery(t5);
  const minHeight = (memoizedCards.length + 1) * (isDesktop ? 435 : 560);
  let t6;
  if ($[14] !== minHeight) {
    t6 = {
      minHeight
    };
    $[14] = minHeight;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== activeTab || $[17] !== props.showTab || $[18] !== tabs) {
    t7 = props.showTab && <Tabs activeTab={activeTab} tabs={tabs} sectionRef={ref} />;
    $[16] = activeTab;
    $[17] = props.showTab;
    $[18] = tabs;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== memoizedCards || $[21] !== props.imagePosition) {
    let t9;
    if ($[23] !== props.imagePosition) {
      t9 = card_1 => props.imagePosition === "right" ? <CardImageOnRight key={card_1.index} {...card_1} /> : <CardImageOnLeft key={card_1.index} {...card_1} />;
      $[23] = props.imagePosition;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    t8 = memoizedCards.map(t9);
    $[20] = memoizedCards;
    $[21] = props.imagePosition;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = <section id="stack-cards" ref={ref} className="content-visibility-auto relative z-10 mx-auto flex max-w-[1168px] flex-col items-center gap-12 px-4 xl:px-0" style={t6}>{t7}{t8}</section>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp(card, index) {
  return {
    id: index,
    label: card.menuTitle
  };
}
export function StackCards(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense><StackCardsComponent {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}